import React, { createContext, useState, JSX } from 'react';
import { DateTime } from 'luxon';
import { useBreakpoint } from '@one-thd/sui-atomic-components';
import { DateRanges } from '../utils/DateRanges';

interface IDateRangeOptions {
  startDate: string;
  endDate: string;
}

export interface ICommonContext {
  dateRangeOptions: IDateRangeOptions;
  setDateRangeOptions: (value: IDateRangeOptions) => void;
  showLoadingOverlay: boolean;
  setShowLoadingOverlay: (value: boolean) => void;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  timezone: string;
}

interface ICommonProvider {
  children: JSX.Element;
}

export const CommonContext = createContext<ICommonContext>({
  dateRangeOptions: {
    startDate: '',
    endDate: '',
  },
  setDateRangeOptions: () => null,
  showLoadingOverlay: false,
  setShowLoadingOverlay: () => null,
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  timezone: '',
});

export const CommonProvider = ({ children }: ICommonProvider) => {
  const [dateRangeOptions, setDateRangeOptions] = useState<IDateRangeOptions>(
    DateRanges.YTD,
  );
  const [showLoadingOverlay, setShowLoadingOverlay] = useState<boolean>(false);

  const isMobile: boolean = useBreakpoint('sm').lesser;
  const isTablet: boolean = useBreakpoint('md').exact;
  const isDesktop: boolean = useBreakpoint('lg').greater;
  const timezone = DateTime.local().zone.name;

  return (
    <CommonContext.Provider
      value={{
        dateRangeOptions,
        setDateRangeOptions,
        showLoadingOverlay,
        setShowLoadingOverlay,
        isMobile,
        isTablet,
        isDesktop,
        timezone,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};

export default CommonProvider;
